<template>
	<div class="home">
		<div class="main-panel">
			<div class="content">


				<div class="panel-header bg-primary-gradient">
					<div class="page-inner py-5">
						<div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">
							<div class="col-md-3">
								<h2 class="text-white pb-2 fw-bold">List Pembangunan</h2>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<div class="input-group">
										<select class="form-control" v-model="form.thn" @change="cari_data()">
                                            <option value="">Pilih Tahun Anggaran</option>
                                            <option value="2016">2016</option>
                                            <option value="2017">2017</option>
                                            <option value="2018">2018</option>
                                            <option value="2019">2019</option>
                                            <option value="2020">2020</option>
                                        </select>
									</div>
								</div>
							</div>
                            <div class="col-md-3 ">
								<div class="form-group">
									<div class="input-group">
										<select class="form-control" v-model="form.prioritas" @change="cari_data()">
                                            <option :value="true">Prioritas</option>
                                            <option :value="false">Bukan Prioritas</option>
                                        </select>
										<div class="input-group-append">
											<button @click="getCetak" class="btn btn-primary" type="button" title="Cetak Data" data-toggle="modal" data-target="#m_cetak_data"><i class="fas fa-print"></i></button>
										</div>
									</div>
								</div>
							</div>

                            <div class="col-md-3 ">
								<div class="form-group">
									<div class="input-group">
										<input v-model="cari_value" @keyup="cari_data()" type="text" class="form-control" placeholder="Cari data ...">
										<div class="input-group-append">
											<button @click="check_add" class="btn btn-primary" type="button" title="Tambah Data" data-toggle="modal" data-target="#m_add_data"><i class="fas fa-plus"></i></button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

<!-- <h1>TES1</h1>


<pdf src="https://crossorigin.me/http://36.89.95.163:5100/uploads/peraturan/1564543467109.pdf"></pdf>
<h1>TES2</h1> -->

				<div class="page-inner mt--5">
					<!-- <h1>asdfad</h1> -->
					<div class="table-responsive" style="background:white; overflow-x:auto;">


                        <table class="table-kiken table table-head-bg-info" width="100%" >
                            <thead>
                                <tr class="bg-primary">
                                    <th scope="col" style="width: 3%">No</th>
									<th scope="col" style="width: 30%">Kegiatan</th>
                                    <th scope="col" style="width: 30%">OPD Pelaksana</th>
                                    <th scope="col" style="width: 20%">Lokasi</th>
                                    <th scope="col" style="width: 17%"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="cek_load_data">
                                    <td colspan="9" class="text-center">
                                        <img src="img/loading-plan.gif" width="450px">
                                    </td>
                                </tr>
                                <template v-if="!cek_load_data" >
                                    <tr class="h_isitable" v-for="(data, index ) in list_data" :key="data.id">
                                        <td class="text-center">{{index+1}}</td>
                                        <td >{{data.kegiatan}}</td>
                                        <td>{{data.unit_kerja}}</td>
                                        <td>{{data.des_kel}}{{data.kecamatan}}</td>
                                        <td class="text-center">


                                            <button @click="editDataPrioritas(data)" class="btn btn-warning btn-icon btn-round btn-xs" title="Edit Data Sementara"><i class="fas fa-file-export"></i></button>
                                            &nbsp;
                                            <button @click="selectData(data)" class="btn btn-success btn-icon btn-round btn-xs" title="Detil Data" data-toggle="modal" data-target="#m_lihat_gambar"><i class="fas fa-images"></i></button>
                                            &nbsp;
                                            <button @click="selectData(data)" class="btn btn-info btn-icon btn-round btn-xs" title="Detil Data" data-toggle="modal" data-target="#m_lihat_data"><i class="fab fa-sistrix"></i></button>
                                            &nbsp;
                                            <button @click="selectData(data)" class="btn btn-warning btn-icon btn-round btn-xs" title="Edit Data" data-toggle="modal" data-target="#m_edit_data"><i class="fas fa-pencil-alt"></i></button>
                                            &nbsp;
                                            <button @click="removeData(data.id)" class="btn btn-danger btn-icon btn-round btn-xs" title="Hapus Data"><i class="fas fa-trash-alt"></i></button>

                                        </td>
                                    </tr>
                                </template>


                            </tbody>
                        </table>

                        <hr>
                            <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <img src="assets/img/sf/sign-left.svg" height="24" width="24">
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <img src="assets/img/sf/sign-right.svg" height="24" width="24">
                                </button>
                            </div>
                        <hr>



					</div>

				</div>




                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_add_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-info">
                                    <h5 class="modal-title">TAMBAH DATA</h5>
                                    <button @click="emptyData()"  type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="addData()">
                                    <div class="modal-body">
                                        <span class="huruf_input">Nama Kegiatan</span>
                                        <input v-model="form.kegiatan" type="text" class="form-control form-control-sm">

                                        <span class="huruf_input">kecamatan</span>
                                        <select  v-model="form.kecamatan" @change="getDeskel()" class="form-control form-control-sm">
                                            <option value="">-- Pilih Kecamatan --</option>
                                            <option v-for="data in list_kec" :key="data.kecamatan_id" :value="data.kecamatan_id">{{data.nama_kecamatan}}</option>
                                        </select>

                                        <span class="huruf_input">Desa Kelurahan</span>
                                        <select class="form-control form-control-sm" v-model="form.des_kel">
                                            <option value="">-- Pilih Desa/Kelurahan --</option>
                                            <option v-for="data in list_des_kel" :key="data.des_kel_id"  :value="data.des_kel_id">{{data.nama_des_kel}}</option>
                                        </select>

                                        <span class="huruf_input">Type Kegiatan</span>
                                        <input v-model="form.kegiatan_type" type="text" class="form-control form-control-sm">

                                        <span class="huruf_input">Anggaran</span>
                                        <input v-model="form.anggaran" type="number" class="form-control form-control-sm">

                                        <span class="huruf_input">Metode</span>
                                        <input v-model="form.metode" type="text" class="form-control form-control-sm">

                                        <span class="huruf_input">Tahun Anggaran</span>
                                        <input v-model="form.thn" type="text" class="form-control form-control-sm">

                                        <span class="huruf_input">Sumber Anggaran</span>
                                        <input v-model="form.sumber_anggaran" type="text" class="form-control form-control-sm">

                                        <span class="huruf_input">Skala Prioritas</span>
                                        <select class="form-control" v-model="form.prioritas">
                                            <option :value="true">Prioritas</option>
                                            <option :value="false">Bukan Prioritas</option>
                                        </select>

                                        <span class="huruf_input">Pelaksana Kegiatan</span>
                                        <input v-model="form.unit_kerja" type="text" class="form-control form-control-sm">

                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-info btn-md">SIMPAN</button>
                                        <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">BATAL</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-warning">
                                    <h5 class="modal-title">EDIT DATA</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">
                                        <span class="huruf_input">Nama Kegiatan</span>
                                        <input v-model="form.kegiatan" type="text" class="form-control form-control-sm">

                                        <span class="huruf_input">kecamatan</span>
                                        <select  v-model="form.kecamatan" @change="getDeskel()" class="form-control form-control-sm">
                                            <option value="">-- Pilih Kecamatan --</option>
                                            <option v-for="data in list_kec" :key="data.kecamatan_id" :value="data.kecamatan_id">{{data.nama_kecamatan}}</option>
                                        </select>

                                        <span class="huruf_input">Desa Kelurahan</span>
                                        <select class="form-control form-control-sm" v-model="form.des_kel">
                                            <option value="">-- Pilih Desa/Kelurahan --</option>
                                            <option v-for="data in list_des_kel" :key="data.des_kel_id"  :value="data.des_kel_id">{{data.nama_des_kel}}</option>
                                        </select>

                                        <span class="huruf_input">Type Kegiatan</span>
                                        <input v-model="form.kegiatan_type" type="text" class="form-control form-control-sm">

                                        <span class="huruf_input">Anggaran</span>
                                        <input v-model="form.anggaran" type="number" class="form-control form-control-sm">

                                        <span class="huruf_input">Metode</span>
                                        <input v-model="form.metode" type="text" class="form-control form-control-sm">

                                        <span class="huruf_input">Tahun Anggaran</span>
                                        <input v-model="form.thn" type="text" class="form-control form-control-sm">

                                        <span class="huruf_input">Sumber Anggaran</span>
                                        <input v-model="form.sumber_anggaran" type="text" class="form-control form-control-sm">

                                        <span class="huruf_input">Skala Prioritas</span>
                                        <select class="form-control" v-model="prioritas">
                                            <option :value="true">Prioritas</option>
                                            <option :value="false">Bukan Prioritas</option>
                                        </select>

                                        <span class="huruf_input">Pelaksana Kegiatan</span>
                                        <input v-model="form.unit_kerja" type="text" class="form-control form-control-sm">
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-warning btn-md">Edit</button>
                                        <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Batal</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->  
                    <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-header">
                                    <h5 class="modal-title">DATA DETIL</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="text-center">
                                        <span class="h_isitable_bold">{{form.kegiatan}}</span> <br>
                                        <span class="h_cetak11">Tgl. {{convert_tgl(form.createAt)}},  &nbsp; Oleh : {{form.createBy}}</span>
                                    </div>
                                    <hr>
                                    <div class="table-responsive">
                                        <table width="100%">
                                            <tr>
                                                <td width="18%"><b>Nama Kegiatan</b></td>
                                                <td width="5%">:</td>
                                                <td width="77%">{{form.kegiatan}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Lokasi</b></td>
                                                <td>:</td>
                                                <td>{{form.kecamatan+', '}}{{form.des_kel}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Anggaran</b></td>
                                                <td>:</td>
                                                <td>Rp. {{format_uang(form.anggaran)}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Sumber Anggaran</b></td>
                                                <td>:</td>
                                                <td>{{form.sumber_anggaran}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>OPD Pelaksanaan</b></td>
                                                <td>:</td>
                                                <td>{{form.unit_kerja}}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Tahun Pelaksanaan</b></td>
                                                <td>:</td>
                                                <td>{{form.thn}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Keluar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->  
                    <div class="modal fade" id="m_lihat_gambar" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-success1">
                                    <h5 class="modal-title">LAMPIRAN DETIL</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="text-center">
                                        <span class="h_isitable_bold">xxxxxxxx</span> <br>
                                        <span class="h_cetak11">Tgl. {{convert_tgl(form.createAt)}},  &nbsp; Oleh : {{form.createBy}}</span>
                                    </div>
                                    <hr>
                                    <div class="table-responsive">
                                        <table>
                                            <thead>

                                            </thead>
                                            <tbody>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Keluar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL CETAK DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->  
                    <div class="modal fade" id="m_cetak_data" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-success">
                                    <h5 class="modal-title">CETAK DATA</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <button class="btn btn-info" @click="Printing">CETAK</button> <hr>
                                    <div   id="printMe">
                                        <div class="text-center">
                                            <span class="h_isitable_bold">DATA CAPAIAN KEGIATAN</span> <br>
                                            <span class="h_cetak11">PEMERINTAH DAERAH KAB. KONAWE SELATAN</span>
                                        </div>
                                        <hr>
                                        <div>
                                            <table class="table-kiken table table-head-bg-info" width="100%" >
                                                <thead>
                                                    <tr class="bg-primary">
                                                        <th scope="col" style="width: 3%">No</th>
                                                        <th scope="col" style="width: 35%">Kegiatan</th>
                                                        <th scope="col" style="width: 30%">Pelaksana</th>
                                                        <th scope="col" style="width: 10%">Anggaran</th>
                                                        <th scope="col" style="width: 5%">TA</th>
                                                        <th scope="col" style="width: 20%">Lokasi</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(data, index) in list_cetak" :key="data.id">
                                                        <td class="text-center">{{index+1}}</td>
                                                        <td>{{data.kegiatan}}</td>
                                                        <td>{{data.unit_kerja}}</td>
                                                        <td>{{format_uang(data.anggaran)}}</td>
                                                        <td>{{data.thn}}</td>
                                                        <td>{{data.des_kel+', '}}{{data.kecamatan}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Keluar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL CETAK DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->





			</div>


		<!-- Footer -->
			<foother></foother>
			<!-- End Footer -->


		</div>
	</div>
</template>

<script>



const ADD_URL = URL_APP + "api/v1/web_capaian_program/";
const ADD_URL_MASTER = URL_APP + "api/v1/web_master_kec/";
const FILE_LOAD = URL_APP + "uploads/";



export default {

    data() {
        return {
            data_load : false,
            form : {
                id : '',
                kegiatan : '',
                kecamatan : '',
                des_kel : '',
                kegiatan_type : '',
                anggaran : '',
                metode : '',
                thn : '2019',
                sumber_anggaran : '',
                prioritas : true,
                unit_kerja : '',
               
                unit_kerja : '',
                createBy : '',
                createAt : '',
            },
            id :'',
            cek_load_data : true,
            file_old: "",
            file_path: FILE_LOAD,
            prioritas : true,

            list_data: [],
            list_kec: [],
            list_des_kel: [],
            list_cetak: [],
            page_first: 1,
            page_last: 0,
            cari_value: "",
        }
    },
    methods: {
        getView: function() {
            this.cek_load_data = true;
            fetch(ADD_URL + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    data_ke: this.page_first,
                    cari_value: this.cari_value,
                    thn: this.form.thn,
                    prioritas: this.form.prioritas
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    // console.log(res_data);
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.cek_load_data = false;
            });
        },

        addData: function() {
            var formData = new FormData();

            formData.append("kegiatan", this.form.kegiatan);
            formData.append("kecamatan", this.form.kecamatan);
            formData.append("des_kel", this.form.des_kel);
            formData.append("kegiatan_type", this.form.kegiatan_type);
            formData.append("anggaran", this.form.anggaran);
            formData.append("metode", this.form.metode);
            formData.append("thn", this.form.thn);
            formData.append("sumber_anggaran", this.form.sumber_anggaran);
            formData.append("prioritas", this.form.prioritas);
            formData.append("unit_kerja", this.form.unit_kerja);


            fetch(ADD_URL + "addData", {
                method: "POST",
                headers: {
                    authorization: "kikensbatara " + localStorage.token
                },
                body: formData
            }).then(res_data => {
                this.alertku("success", "sukses menambah data");
                this.getView();
            });
        },

        editData: function() {
            var formData = new FormData();
            formData.append("id", this.form.id);
            formData.append("kegiatan", this.form.kegiatan);
            formData.append("kecamatan", this.form.kecamatan);
            formData.append("des_kel", this.form.des_kel);
            formData.append("kegiatan_type", this.form.kegiatan_type);
            formData.append("anggaran", this.form.anggaran);
            formData.append("metode", this.form.metode);
            formData.append("thn", this.form.thn);
            formData.append("sumber_anggaran", this.form.sumber_anggaran);
            formData.append("prioritas", this.prioritas);
            formData.append("unit_kerja", this.form.unit_kerja);



            fetch(ADD_URL + "editData", {
                method: "POST",
                headers: {
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: formData
            }).then(res_data => {
                this.alertku("success", "Sukses merubah data");
                this.getView();
            });
        },


        editDataPrioritas: function(data) {
            var formData = new FormData();
            formData.append("id", data.id);
            formData.append("prioritas", false);

            fetch(ADD_URL + "editDataPrioritas", {
                method: "POST",
                headers: {
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: formData
            }).then(res_data => {
                this.alertku("success", "Sukses merubah data");
                this.getView();
            });
        },

        selectData: function(data) {
            var prioritas = true
            if (data.prioritas == 1) {
                prioritas = true;
            } else {
                prioritas = false;
            }
            this.form = {
                id : data.id,
                kegiatan : data.kegiatan,
                kecamatan : data.kecamatan,
                des_kel : data.des_kel,
                kegiatan_type : data.kegiatan_type,
                anggaran : data.anggaran,
                metode : data.metode,
                thn : data.thn,
                sumber_anggaran : data.sumber_anggaran,
                prioritas : prioritas,
                unit_kerja :  data.unit_kerja,
               
                unit_kerja : data.unit_kerja,
                createBy : data.createBy,
                createAt : data.createAt,
            };
            this.file_old =  data.foto;
            this.getKec();
            this.getDeskel();

            this.prioritas = prioritas;
            // CKEDITOR.instances.editor1.setData(data.isi);
        },

        emptyData : function(){
            this.list_kec = [];
            this.list_des_kel = [];
        },
        removeData: function(idnya) {
            fetch(ADD_URL + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                    body: JSON.stringify({
                    id: idnya,
                })
            }).then(res_data => {
                this.getView();
                this.alertku("success", "sukses menghapus data");
                this.fileku = null;
            });
        },

    // ================== TAMBAHAN ====================
        check_add : function(){
            this.getKec();
        },
        getKec: function(idnya) {
            fetch(ADD_URL_MASTER, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            }).then(res => res.json())
                .then(res_data => {
                this.list_kec = res_data
                
            });
        },
        getDeskel: function() {
            // this.cek_load_data = true;
            fetch(ADD_URL_MASTER + "get_des_kel", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    kecamatan : this.form.kecamatan
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    console.log(res_data);
                this.list_des_kel = res_data;

            });
        },

        getCetak: function() {
            fetch(ADD_URL + "cetak", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    data_ke: this.page_first,
                    cari_value: this.cari_value,
                    thn: this.form.thn,
                    prioritas: this.form.prioritas
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    console.log(res_data);
                this.list_cetak = res_data;
            });
        },
    // ================== TAMBAHAN ====================

    // ================== PAGINASI ====================
        alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
        },

        btn_prev : function(){
                this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){

            this.page_first = 1;
            this.getView();
        },

        onFileSelected: function(event) {
            this.form.file = event.target.files[0];
        },
        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            var getBulan = date.getMonth() + 1; var bulan = '';
            if (getBulan == '1') {bulan = 'Jan'} 
            else if(getBulan == '2') {bulan = 'Feb'}
            else if(getBulan == '3') {bulan = 'Mar'}
            else if(getBulan == '4') {bulan = 'Apr'}
            else if(getBulan == '5') {bulan = 'Mei'}
            else if(getBulan == '6') {bulan = 'Jun'}
            else if(getBulan == '7') {bulan = 'Jul'}
            else if(getBulan == '8') {bulan = 'Agt'}
            else if(getBulan == '9') {bulan = 'Sep'}
            else if(getBulan == '10') {bulan = 'Okt'}
            else if(getBulan == '11') {bulan = 'Nov'}
            else if(getBulan == '12') {bulan = 'Des'}

            return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
        },
        format_uang : function(nilai, prefix){
            var angka = parseFloat(nilai)
            if (angka == null || angka == '' || angka == undefined) {
                return angka;
            } else {
                var rupiah = '';		
                var angkarev = angka.toString().split('').reverse().join('');
                for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
                return ''+rupiah.split('',rupiah.length-1).reverse().join('');
            }
        },
        Printing : function(){
            // printMe
            var elem = document.getElementById("printMe");
            var domClone = elem.cloneNode(true);

            var $printSection = document.getElementById("printSection");

            if (!$printSection) {
                var $printSection = document.createElement("div");
                $printSection.id = "printSection";
                document.body.appendChild($printSection);
            }

            $printSection.innerHTML = "";
            $printSection.appendChild(domClone);
            window.print();

        },
        
    },
    mounted() {
        var get_profile = JSON.parse(localStorage.profile);
        // this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
        this.form.unit_kerja = get_profile.profile.unit_kerja;
        this.getView();
    },

}
</script>